// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1DwL6","primary":"_3ncWL","secondary":"rX_jC","secondary-visible":"_1vDSE","secondaryVisible":"_1vDSE"};